import axios from 'axios'
import * as types from '../mutation-types'

// state
export const state = {
  evaluations: [],
  icons: {
    'abilities': 'user',
    'requirements': 'wrench',
    'perceptions': ['far', 'eye']
  }
}

// getters
export const getters = {
  evaluations: state => state.evaluations,
  abilities: state => state.evaluations.find(e => e.title == 'abilities'),
  requirements: state => state.evaluations.find(e => e.title == 'requirements'),
  perceptions: state => state.evaluations.find(e => e.title == 'perceptions')
}

// mutations
export const mutations = {
  [types.FETCH_EVALUATIONS_SUCCESS] (state, { evaluations }) {
    // Merge icons to evaluations.
    state.evaluations = evaluations.map(
      (e) => e = { ...e, 'icon': state.icons[e.title] }
    )
  },

  [types.FETCH_EVALUATIONS_FAILURE] (state) {
    // Fallback.
    state.evaluations = [
      { id: 0, name: 'abilities', icon: state.icons['abilities'], default_value: 5 },
      { id: 1, name: 'requirements', icon: state.icons['requirements'], default_value: 5 },
      { id: 2, name: 'perceptions', icon: state.icons['perceptions'], default_value: 5 }
    ]
  }
}

// actions
export const actions = {
  async fetchEvaluations ({ commit }) {
    try {
      const response = await axios.get(`/api/evaluations`)
      commit(types.FETCH_EVALUATIONS_SUCCESS, { evaluations: response.data })
    } catch (error) {
      console.error(error)
      commit(types.FETCH_EVALUATIONS_FAILURE)
    }
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/evaluations.js